export default __webpack_public_path__ + "static/media/cylinder.3fc0d4ce.png";